export const fullBrandName = {
  Eurostar: 'Eurostar',
  'TGV INOUI': 'SNCF',
  SNCB: 'SNCB',
  Lyria: 'Lyria',
  DB: 'Deutsche Bahn',
  ICE: 'Deutsche Bahn',
  IC: 'Deutsche Bahn',
  NS: 'Nederlandse Spoorwegen'
};

export const getFullBrandNameFromBrandCode = ({ brandCode }) => fullBrandName[brandCode];
